import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuerySearchParams } from '@/hooks/use-query-search-params'
import { useSurveyForm } from '@/hooks/use-survey-form'
import { SurveyFormTemplate } from '@/components/template/survey-form-template'
import { SurveySource } from '@/features/survey/survey-types'
import { SurveyForm } from '@/components/organisms/survey/survey-form'
import { useAppSelector } from '@/app/hooks'
import { SurveyFormData } from '@/features/survey/survey-types'

/**
 * アンケート詳細ページ
 * 単体のアンケート回答ページ（チェックアウトフロー外）
 */
export const SurveyDetail = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { hotelId, source } = useQuerySearchParams<{ hotelId: string; source?: SurveySource }>()
  const reservationIds = useAppSelector(state => state.survey.surveyQuestions.survey?.reservationIds)

  // クエリパラメーターからhotelIdと流入経路を取得
  const surveySource = source ?? 'direct_link'
  const { useFormReturn, questions, handleSurveySubmit, loadingSurveyForm } = useSurveyForm({
    source: surveySource,
    hotelId,
  })

  // 必須パラメータのバリデーション
  // 回答可能な予約IDがなければ404エラーを表示
  if (!reservationIds || reservationIds.length === 0) {
    return <Navigate to="/error-404" />
  }

  const { handleSubmit } = useFormReturn

  const onSubmit = async (data: { answers: SurveyFormData }) => {
    const result = await handleSurveySubmit(data)
    // アンケート回答成功時
    if (result?.success) {
      navigate('/survey/thanks')
      // アンケート回答重複時
    } else if (result?.error === 'duplicate') {
      navigate('/survey/duplicate-answer')
      // その他のエラー時
    } else if (result?.error === 'unknown') {
      navigate('/error-404')
    }
  }

  return (
    <SurveyFormTemplate
      title={t('Enquete')}
      loading={loadingSurveyForm}
      methods={useFormReturn}
      form={<SurveyForm questions={questions} onSubmit={handleSubmit(onSubmit)} buttonText={t('Submit')} />}
    />
  )
}
